import { RefObject } from 'react';
import { MenuType, TIframeSettings } from '../types';

export enum TourType {
  Regular = 'regular',
  Conference = 'conference',
  Game = 'game',
  ECommerce = 'ecommerce',
  Ticket = 'ticket',
  Kiosk = 'kiosk'
}

export interface TMenuObject {
  id?: number;
  label: string; //change title to label to match admin repo
  url?: string;
  type: MenuType;
  subMenus?: TMenuObject[];
  subSubMenus?: TMenuObject[];
  panoramaId?: number;
  tag?: string;
  labelId?: string;
  floorId?: number;
  changeMinimap?: boolean;
  changePanorama?: boolean;
  iframeSettings?: TIframeSettings;
}

export type TMenuSettingsType = {
  menuEnabled: boolean;
  menuOnStart: boolean;
  menuAlwaysOpenDesktop: boolean;
  menuAlwaysOpenMobile: boolean;
  menuTooltipOn: boolean;
  menuSearch: boolean;
  menuCategoryExpand: boolean;
  bookUrl: string;
  bookText: string;
  bookColor: string;
  menuBgColor: string;
  menuActiveColor: string;
  menuTxtColor: string;
  bookActiveColor: string;
  bookTxtColor: string;

  autoNav: boolean;
  menus: TMenuObject[];
  rotationAngle: number | null;
  rotationSpeed: number | null;
  showNavPath: boolean;
  showNavTools: boolean;
  stopAfterSweep: number | null;
  teleportNav: boolean;
  tourId: number;
  transitionSpeed: number | null;
  walkNav: boolean;
};

export type TButtonBgProps = {
  menuOpen: boolean;
  chatToken?: string;
  tour: any;
  host?: string;
  menuOpenForDevice?: boolean;
  tourType?: string;
  MenuHintOn: boolean;
  translation: any;
  showExpand: boolean;
  tourEmail: any;
  showCustomButton: boolean;
  getInTouchHintOn: boolean;
  toggleContactPopup: () => void;
  appointmentsHintOn: boolean;
  toggleAppointmentsModal: () => void;
  handleCustomButton: () => void;
  toggleNav: () => void;
  menu: TMenuSettingsType;
  menuColors: TMenuColorsProps;
  openOnHover?: boolean;
};

export interface MenuNavProps {
  rtl?: boolean;
  menus: any;
  openMenu: (i: number, j: number | null) => void;
  loadModel: (...args: any) => void;
  menuRef: any;
  menuColors: TMenuColorsProps;
  whitelabel?: any;
}

export type TMenuType = {
  changeMinimap: boolean;
  changePanorama: boolean;
  createdAt: Date;
  floorId: number | null;
  icon: string | null;
  id: number;
  labelId: number | null;
  order: number;
  panoramaId: number | null;
  subMenus: TMenuType[];
  subSubMenus: TMenuType[];
  tag: null;
  title: string;
  tourId: number;
  type: string;
  updatedAt: Date;
  url: string;
  open?: boolean;
  menuId: number;
};

export type TButtonProps = {
  active: string;
  passive: string;
  text: string;
};

export type TMenuColorsProps = {
  fon: string;
  active: string;
  text: string;
  searchButtonColor: string;
  openedMenuColor: string;
  scrollbarColor?: string;
};

export type TBurgerMenuProps = {
  bookUrl?: string;
  bookText: string;
  buttonColors: TButtonProps;
  menuColors: TMenuColorsProps;
  menuSearch: boolean;
  translation: any;
  bookAppointment?: boolean;
  contact: any;
  address?: string;
  whitelabel: any;
  menuOpen: boolean;
  rtl?: boolean;
  openOnHover?: boolean;
  isHorizontalMobileView?: boolean;
  inputSearchRef?: RefObject<HTMLInputElement>;
  toggleAppointmentsModal: () => void;
  toggleContactPopup: () => void;
  toggleAddressPopup: () => void;
  menus: any;
  menuRef?: RefObject<HTMLUListElement>;
  chatToken?: string;
  tour: any;
  host?: string;
  menuOpenForDevice?: boolean;
  tourType?: string;
  MenuHintOn: boolean;
  tourEmail: any;
  showCustomButton: boolean;
  getInTouchHintOn: boolean;
  appointmentsHintOn: boolean;
  handleCustomButton: () => void;
  menuOpened: boolean;
  menu: TMenuSettingsType;
  showcase: any;
  publicSweeps: any;
  fromAdmin?: boolean;
  windowWidth?: number;
  panoramas?: any;
  awsUrl?: string;
  tags?: any;
};

export enum TourMode {
  DOLLHOUSE = 'mode.dollhouse',
  FLOORPLAN = 'mode.floorplan',
  INSIDE = 'mode.inside',
  OUTSIDE = 'mode.outside',
  TRANSITIONING = 'mode.transitioning'
}
